var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0827AE24-3090-48B8-A3E4-39E110B2DE91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Team-Edit-Specialties",
    transform: "translate(-522.000000, -361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(492.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(30.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43DAD4",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7165495,7.14666007 C18.8251733,7.92309371 18.00571,8.74255699 17.186144,9.59080085 C16.3810325,10.4391474 15.5902471,11.301743 14.8282423,12.1931193 C13.7068012,13.5301707 12.6284924,14.9248347 11.622071,16.3625797 L7.97019873,12.4375359 C7.79770014,12.2505982 7.51017169,12.1931321 7.28010682,12.336845 C7.0069096,12.4950021 6.92067058,12.8401071 7.07882766,13.1131759 C7.07882766,13.1131759 10.5581705,19.1085724 10.701945,19.3673665 C10.8457606,19.6117703 11.1620747,20 11.8090343,20 C12.4416678,20 12.7866495,19.626212 12.9880365,19.2379952 C13.2036572,18.8354266 15.1303022,15.269819 16.3811147,13.3863731 C16.9992936,12.4374358 17.6750338,11.517279 18.3507996,10.6115253 C19.0408915,9.70572032 19.759764,8.81434411 20.4930653,7.98045203 L20.5074065,7.96611078 C20.694244,7.72170697 20.694244,7.40539024 20.5073062,7.18967715 C20.3060557,6.95972242 19.9466144,6.93104197 19.7165495,7.14666007 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.28340e28620ee2b5f13228bca963fcfe.svg";
export { ForwardRef as ReactComponent };